import { render, staticRenderFns } from "./GallerySlides.vue?vue&type=template&id=2ebbf619&scoped=true&"
import script from "./GallerySlides.vue?vue&type=script&lang=js&"
export * from "./GallerySlides.vue?vue&type=script&lang=js&"
import style0 from "./GallerySlides.vue?vue&type=style&index=0&id=2ebbf619&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebbf619",
  null
  
)

export default component.exports